import moment from 'moment';
import React from 'react';
import { Modal } from 'react-bootstrap';
import { Scrollbars } from 'react-custom-scrollbars';

const CommonShowDetails = ({ showAllDetails, setShowAllDetails, data, travel_data = false, allowedColumns = null }) => {
    let headerData = {
        // Step 1: Personal & GST Details
        visitor_name: "Visitor Name",
        mobile_number: "Mobile Number",
        email: "Email",
        designation: "Designation",
        company_name: "Company Name",
        gst_number: "GST Number",
        country: "Country",
        street_address: "Address",
        city: "City",
        state: "State",
        postal_code: "Pincode",
        
        // Communication Address
        sameAddress: "Same as GST Address",
        commAddress: "Communication Address",
        commCity: "Communication City",
        commPincode: "Communication Pincode",
        commState: "Communication State",

        // Step 2: Document Uploads
        photo: "Profile Photo",
        id_proof_front: "ID Proof Front",
        id_proof_back: "ID Proof Back",

        // Step 3: Travel & Stay Information
        arrivalMode: "Arrival Mode",
        arrivalFrom: "Arrival From City",
        arrivalDate: "Arrival Date",
        arrivalTime: "Arrival Time",
        modeDetails: "Flight/Train Details",
        ticket: "Travel Ticket",
        stayDuration: "Stay Duration",
        stayOption: "Stay Option (1/2 Nights)",
        requiresCab: "Cab Required",
        departureDate: "Departure Date",
        departureTime: "Departure Time",
        departureMode: "Departure Mode",

        // Common Fields
        barcode: "Barcode",
        created_at: "Registration Date"
    };

    // Filter headerData if allowedColumns is provided
    if (allowedColumns && Array.isArray(allowedColumns)) {
        const filteredHeader = {};
        allowedColumns.forEach(col => {
            if (headerData[col]) {
                filteredHeader[col] = headerData[col];
            }
        });
        // Always include basic info if missing? No, follow strict permissions.
        // But some fields like visitor_name might be good for title context.
        headerData = filteredHeader;
    }

    const renderFieldValue = (key, value) => {
        // Handle file fields
        if (key === 'photo') {
            return value ? (
                <a href={`${process.env.REACT_APP_IMAGE_URL}/photo/${value}?v=${moment().unix()}`}
                  target="_blank" 
                  rel="noopener noreferrer">
                    View Document
                </a>
            ) : 'Not uploaded';
        }
        else if(['id_proof_front', 'id_proof_back', 'gst_certificate', 'pan_card', 'vaccination_certificate', 'exhibitor_logo', 'logo'].includes(key)) {
            return value ? (
                <a href={`${process.env.REACT_APP_IMAGE_URL}/${(key === 'exhibitor_logo' || key === 'logo') ? 'exhibitor_logo' : 'id_proof'}/${value}?v=${moment().unix()}`}
                target="_blank" 
                rel="noopener noreferrer">
                    View Document
                </a>
            ) : 'Not uploaded';
        }
        else if (key === 'ticket' || key === 'upload_ticket') {
            return value ? (
                <a href={`${process.env.REACT_APP_IMAGE_URL}/tickets/${value}?v=${moment().unix()}`}
                target="_blank" 
                rel="noopener noreferrer">
                    View Ticket
                </a>
            ) : 'Not uploaded';
        }
        // Handle boolean field
        if (key === 'sameAddress') {
            return value ? 'Yes' : 'No';
        }
        
        return value || 'N/A';
    };

    return (
        <Modal
            show={showAllDetails}
            onHide={() => setShowAllDetails(false)}
            animation={false}
            centered
            backdrop="static"
            size="lg"
        >
            <Modal.Header closeButton>
                <Modal.Title>
                    <div className="mx-auto px-5">
                        <span className="text-center mx-auto">
                            {data?.visitor_name || 'Visitor'} Details
                        </span>
                    </div>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Scrollbars style={{ height: '70vh' }}>
                    {data ? (
                        <div className="row">
                            {Object.entries(headerData).map(([key, label]) => (
                                <div key={key} className="col-md-6 mb-3">
                                    <div className="card h-100 shadow-sm">
                                        <div className="card-body">
                                            <h6 className="card-subtitle mb-2 text-muted">{label}</h6>
                                            <p className="card-text">
                                                {data[key]==="null" || data[key] == null || data[key] == "" ? "-" : renderFieldValue(key, data[key])}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    ) : (
                        <div className="text-center py-4">No data available</div>
                    )}
                </Scrollbars>
            </Modal.Body>
        </Modal>
    );
};

export default CommonShowDetails;
